import { useQuery } from "@tanstack/react-query";

const urlPerfil = process.env.REACT_APP_URL_DIR + "perfil";

export function Perfil() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["perfil"],
      queryFn: () =>
         fetch(urlPerfil, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export default Perfil;
